module.exports = __webpack_public_path__ + "img/bananaprint.d59fe2b3.png";